import useTranslation from 'next-translate/useTranslation'
import React from 'react'
import useSession from 'tennders-auth/hooks/useSession'
import GImage from 'tennders-market/common/components/element/GImage'
import GHref from 'tennders-market/common/components/element/GHref'
import useTransactionDetailStore from 'tennders-transactions/stores/useTransactionDetailStore'
import Trans from 'next-translate/Trans'
import get from 'lodash/get'
import { useRouter } from 'next/router'
import RequiresPermission from 'tennders-auth/components/RequiresPermission'
import { dispatchShareLoadBox, dispatchCarrierShareBox } from 'tennders-common/stores/modal/action'
import { useDispatch } from 'react-redux'
import RequiresCondition from 'tennders-auth/components/RequiresCondition'
import { STATUS_READY_TO_PAIR } from 'tennders-stracture/libs/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import IconCarrier from '../../../../icons/icon-assign-carrier.svg'
import IconTruck from '../../../../icons/icon-assign-truck.svg'
import IconMarketplace from '../../../../icons/icon-marketplace.svg'

const ShareWithMarketPlaceButton = ({ transaction }) => {
  const { t } = useTranslation()
  const { isNetworkUser } = useSession()
  const dispatch = useDispatch()
  const openShareLoadBox = () => dispatch(dispatchShareLoadBox({
    withoutMarketPlace: transaction?.isMarketPlaced,
    transactionId: transaction?.id,
    singleTransaction: true
  }))
  const openCarrierShareBox = () => dispatch(dispatchCarrierShareBox({
    withoutMarketPlace: transaction?.isMarketPlaced,
    transactionId: transaction?.id,
    singleTransaction: true,
    isSharedWithAll: transaction?.matchedLoad?.isSharedWithAll || transaction?.isSharedWithAll
  }))

  return (
    <div className="pos-rel">
      <GHref
        onClick={() => (isNetworkUser() ? openShareLoadBox() : openCarrierShareBox())}
        className="btn standard-btn medium"
      >
        <IconMarketplace className="m-auto" />
        {t('addLoad:share')}
      </GHref>
    </div>
  )
}

const AssignTrucksButton = ({ transaction }) => {
  const { t } = useTranslation()
  const router = useRouter()

  const [isFixed, toggle] = useTransactionDetailStore(
    state => [state.assignTruckLoadType, state.toggleTruckAssign]
  )

  return (
    isFixed ? (
      <GHref onClick={toggle} className="btn-border standard-btn medium">
        <FontAwesomeIcon icon={faArrowLeft} className="mr-4" aria-hidden="true" />
        <Trans i18nKey="transaction:backToNegotiation" />
      </GHref>
    ) : (
      <div className="d-flex row">
        <GHref
          onClick={!transaction.isOpenToQC ? null : () => {
            router.push({
              pathname: `/loadboard/${get(transaction?.matchedLoad, 'id')}/assign-carrier`,
              query: { from: router.asPath }
            })
          }}
          disabled={!transaction.isOpenToQC}
          tip={!transaction.isOpenToQC ? t('transaction:notAssignableLoadMessage', { state: t('variables:' + transaction?.matchedLoad?.company?.state?.label) }) : null}
          className="btn standard-btn medium mr-4 mb-4"
        >
          <IconCarrier className="m-auto" />
          {t('transaction:assign_carrier')}
        </GHref>
        <GHref
          onClick={toggle}
          className="btn standard-btn medium mr-4 mb-4"
        >
          <IconTruck />
          {t('transaction:assignTrucks')}
        </GHref>
        <RequiresCondition
          requiredCondition={!(transaction?.matchedLoad?.isMarketPlaced)}
          fallbackComponent={(
            <GHref className="btn standard-btn medium mb-4" tip={t('addLoad:mp_load_cannot_be_shared')}>
              <IconMarketplace className="m-auto" />
              {t('addLoad:share')}
            </GHref>
          )}>
          <ShareWithMarketPlaceButton transaction={transaction} />
        </RequiresCondition>
      </div>
    )
  )
}

const FindTruckButton = ({ transaction, withIcon }) => {
  const { t } = useTranslation()
  const { isBroker } = useSession()
  const [isFixed, toggle] = useTransactionDetailStore(
    state => [state.assignTruckLoadType, state.toggleTruckAssign]
  )

  if (!transaction?.isMarketPlaced && !isBroker()) {
    return null
  }

  if (transaction?.isPassive) {
    return null
  }

  if (transaction?.isBooked) {
    return <AssignTrucksButton transaction={transaction} />
  }

  if (withIcon) {
    return (
      <GHref onClick={toggle}>
        <GImage width={32} className="m-auto" src="trucks.svg" />
        {t('transaction:matchTrucks')}
      </GHref>
    )
  }

  return (
    isFixed ? (
      <GHref onClick={toggle} className="btn-border standard-btn medium">
        <FontAwesomeIcon icon={faArrowLeft} className="mr-4" aria-hidden="true" />
        <Trans i18nKey="transaction:backToNegotiation" />
      </GHref>
    ) : transaction?.matchedLoad?.internalOwner ? (
      <GHref
        onClick={toggle}
        className="btn-border standard-btn medium tennders-brokers-find-trucks-btn"
      >
        {t('transaction:matchTrucks')}
      </GHref>
    ) : null
  )
}

export default FindTruckButton
